import { Lagerplatz } from './lagerplatz';

export interface Palette {
  id: number;
  sscc: string;
  menge: number;
  lagerplatz?: Lagerplatz;
  extref?: string;
  kunde?: Record<string, unknown>;
  mischpalette?: 'J' | 'N';
  einheit: {
    id: number;
    arteh: string;
  };
}
